<template>
  <main-page-content classification="MARKETING_DRY"></main-page-content>
</template>

<script>
import MainPageContent from "./components/MainPageContent.vue";

// import reqwest from 'reqwest';

export default {
  metaInfo: {
    title: '营销干货-AB客外贸学院'
  },
  components: {
    MainPageContent,
  },
};
</script>
